/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ReleaseMessageMaxTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('RELEASE_MESSAGE_MAX_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class ReleaseMessageMaxTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ReleaseMessageMaxTimeSettingParser.decode(input).map(res => new ReleaseMessageMaxTimeSetting(res));
    }
    static unsafeDecode(input) {
        return ReleaseMessageMaxTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ReleaseMessageMaxTimeSettingParser.encode(data);
    }
    static schema() {
        return ReleaseMessageMaxTimeSettingParser.schema();
    }
}
